import { render } from "./PromptControl.vue?vue&type=template&id=8a0efde4"
import script from "./PromptControl.vue?vue&type=script&lang=js"
export * from "./PromptControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__